import { useState, useRef, useEffect } from 'react';
import { useHistory } from "react-router";
import Sidebar from '../../../components/Navigation/Sidebar';
import Topbar from '../../../components/Navigation/Topbar';
import Header from '../../../components/Page/header';
import { ConvertToMoney } from '../../../utils/formattingUtils';
import { buttonIcon, buttonTypes } from "../../../utils/buttonsUtil";
import Grid from '../../../components/Grid';
import { connect } from "react-redux";
import ReasonFailedAssignmentModal from "../../../components/Modal/AutomaticAssigmentAlert/ReasonFailedAssignment/index" 

const FailedOrdersAssigners = ({
    failedAddressesToAutomaticAssingment,
    reduxDownloadFailedAutomaticAssigment,
    reduxResetStatusRecordAutomaticAssignment,
    reduxGetAllFailedAddressesToautomaticAssigment,
    reduxResetAllFailedAddressesToAutomaticAssigment
}) => {

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const history = useHistory();
    const searchRef = useRef("");

    const [addresses, setAddresses] = useState({});
    const [showFailedReasonModal, setShowFailedReasonModal] = useState(false);
    const [selectedIdAddress, setSelectedIdAddres] = useState();
    const [offset, setOffset] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [defaultStartDate, setDefaultStartDate] = useState(formatDate(new Date()));
    const [defaultEndDate, setDefaultEndDate] = useState(formatDate(new Date()));

    useEffect(() => {
        let filters = {
            from: defaultStartDate,
            to: defaultEndDate,
            page: currentPage,
            search,
            offset,
        };

        reduxGetAllFailedAddressesToautomaticAssigment(filters);
    }, [currentPage, offset])

    useEffect(() => {
        return () => {
            reduxResetAllFailedAddressesToAutomaticAssigment();
        };
    }, []);

    const actionButtons = [
        {
            onClick: () => history.push("/assigner"),
            description: "Ir al dashboard de asignador automático",
            buttonType: buttonTypes.Primary,
            buttonIcon: buttonIcon.Arrow_LeftReply,
        },
    ];

    const customStyles = {
        FailedOrdersColorCard: {
            background: '#e74a3b',
            background: 'linear-gradient(90deg, rgba(231, 74, 59, 0.76) 58%, rgba(231, 74, 59, 1) 100%)',    
        },
        downloadButton: {
            backgroundColor: 'rgba(231, 74, 59, 1)',
            borderColor: 'rgba(231, 74, 59, 1)',
            color: '#fff'
        }
    };

    const columns = [
        {
            title: '#',
            render: (rowData) => {
                return <span>{rowData.idAddress}</span>;
            },
            field: 'idAddress',
            searchable: true,
        },
        {
            title: 'Remitente',
            render: (rowData) => {
                return <span>{rowData.shipperName ? rowData.shipperName : ''}</span>;
            },
            field: 'company.description',
            searchable: true,
        },
        {
            title: 'Valor Declarado',
            render: (rowData) => {
                return <span>{ConvertToMoney(rowData.collection)}</span>;
            }
        },
        {
            title: 'Dirección',
            render: (rowData) => {
                return <span>{rowData.address}</span>;
            },
        },
        {
            title: 'Ciudad destino',
            render: (rowData) => {
                return <span>{rowData.cityNameReceiver ? rowData.cityNameReceiver.toUpperCase() : ''}</span>;
            },
            field: 'city.description',
            searchable: true,
        },
        {
            title: 'Fecha Creación',
            render: (rowData) => {
                const fecha = rowData.createdAt ? rowData.createdAt.split('T')[0] : '';
                return <span>{fecha}</span>;
            },
        },
        {
            title: 'ID Externo',
            render: (rowData) => {
                return <span>{rowData.externalId}</span>;
            },
            field: 'externalId',
            searchable: true,
        },
        {
            title: 'Operador',
            render: (rowData) => {
                return <span>{rowData.operatorName ? rowData.operatorName : ''}</span>;
            }
        },
        {
            title: 'Acciones',
            render: (rowData) => {
                return (
                    <button
                        title={'Ver razón de la falla'}
                        className={`btn ${buttonTypes.Primary} btn-circle`}
                        type="button"
                        onClick={() => {
                            setSelectedIdAddres(rowData.idAddress)
                            setShowFailedReasonModal(true)
                        }}
                    >
                        <i className={`fas ${buttonIcon.Info}`}></i>
                    </button>
                )
            }
        }
    ]

    const handleCloseModal = () => {
        setShowFailedReasonModal(false);
        setSelectedIdAddres(null);
        reduxResetStatusRecordAutomaticAssignment();
    }

    return (
        <div id='wrapper'>
            <Sidebar />
            <div id='content-wrapper' className='d-flex flex-column'>
                <div id='content'>
                    <Topbar />
                    <div className="container-fluid">
                        <Header title={"Órdenes fallidas"} actionButtons={actionButtons} />

                        <div className='card shadow mb-4'>
                            <div className='card-header py-3'>
                                <h6 className='m-0 font-weight-bold text-primary'>Listado de Órdenes</h6>
                            </div>

                            <div className='d-flex align-items-center justify-content-end mt-2 mr-4'>

                                <div className='card shadow mb-0' style={customStyles.FailedOrdersColorCard}>
                                    <div className='mx-3 pt-1 pb-2'>
                                        <div className='row no-gutters align-items-center'>
                                            <div className='col mr-2'>
                                                <div className='text-xs font-weight-bold text-uppercase text-white'>
                                                    Órdenes fallidas hoy:
                                                </div>
                                            </div>
                                            <div className='h5 mb-0 font-weight-bold text-white'>
                                                {failedAddressesToAutomaticAssingment && failedAddressesToAutomaticAssingment.hasOwnProperty('total') ? failedAddressesToAutomaticAssingment.total : 0}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <button
                                    title='Descargar lista de órdenes fallidas'
                                    className='btn ml-1'
                                    type='button'
                                    style={customStyles.downloadButton}
                                    onClick={() => reduxDownloadFailedAutomaticAssigment({
                                        from: formatDate(new Date()),
                                        to: formatDate(new Date()),
                                        search: searchRef.current 
                                    })}>
                                    <i className='fas fa-file-download fa-sm'></i>
                                </button>
                            </div>

                            <div className='card-body'>
                                <Grid
                                    className='stickyAddress'
                                    cols={columns}
                                    data={failedAddressesToAutomaticAssingment && Object.keys(failedAddressesToAutomaticAssingment).length > 0 ? failedAddressesToAutomaticAssingment.items : []}
                                    total={failedAddressesToAutomaticAssingment && failedAddressesToAutomaticAssingment.hasOwnProperty('total') ? failedAddressesToAutomaticAssingment.total : 0}
                                    page={failedAddressesToAutomaticAssingment && Object.keys(failedAddressesToAutomaticAssingment).length > 0 ? Number(failedAddressesToAutomaticAssingment.page) : currentPage}
                                    pages={failedAddressesToAutomaticAssingment && Object.keys(failedAddressesToAutomaticAssingment).length > 0 ? Number(failedAddressesToAutomaticAssingment.totalPages) : 0}
                                    offset={offset}
                                    onChangePage={(page) => setCurrentPage(page)}
                                    onChangeRange={(value) => {
                                        setOffset(value);
                                        setCurrentPage(1);
                                    }}
                                    onChangeSearch={(value) => {
                                        setSearch(value)
                                        searchRef.current = value;

                                        const filters = {
                                            page: currentPage,
                                            offset,
                                            search: value,
                                            from: startDate ? formatDate(startDate) : defaultStartDate,
                                            to: endDate ? formatDate(endDate) : defaultEndDate,
                                        }

                                        reduxGetAllFailedAddressesToautomaticAssigment(filters);
                                    }}
                                >
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ReasonFailedAssignmentModal 
                selectedIdAddress = {selectedIdAddress}
                showFailedReason = {showFailedReasonModal}
                handleCloseModal = {handleCloseModal}
            >
            </ReasonFailedAssignmentModal>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        failedAddressesToAutomaticAssingment: state.addressToAutomaticAssigmentState.failedAddressesToAutomaticAssingment,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reduxGetAllFailedAddressesToautomaticAssigment: (payload) =>
            dispatch({
                type: "GetAllFailedAddressesToAutomaticAssigment",
                value: payload,
            }),
        reduxDownloadFailedAutomaticAssigment: (payload) =>
            dispatch({
                type: "DownloadFailedAutomaticAssigment",
                value: payload,
            }),
        reduxResetAllFailedAddressesToAutomaticAssigment: () =>
            dispatch({ type: "RESET_ALL_FAILED_ADDRESSES_TO_AUTOMATIC_ASSIGMENT" }),
        reduxResetStatusRecordAutomaticAssignment: () => 
            dispatch({ type: "RESET_STATUS_RECORD_AUTOMATIC_ASSIGNMENT" }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FailedOrdersAssigners);